import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ResponsiveForm from './components/UserData';
 import DoorConfig from './components/doorConfig';
import NextPage from './components/InfoTable';
import UserInfo from './UserInfo';
import UserTable from './components/UserTable';
import NewEditUser from './components/NewEditUser';
import EditUser from './components/EditUser';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ResponsiveForm />} />
        <Route path="/display" element={<UserInfo />} />
        <Route path="/components/doorConfig/:id" element={<DoorConfig />} />
        <Route path="/components/UserTable" element={<UserTable />} />
        <Route path="/components/NewEditUser/:id" element={<NewEditUser />} />

       
        <Route path="/next-page" element={<NextPage />} />
      </Routes>
    </Router>
  );
}

export default App;
